import React, { useEffect, useCallback, useState} from 'react';
import EffectChoice from './EffectChoice.js';
import {connect} from 'react-redux';

const EffectChoices = ({effects, sequencerEngine, selectedEffect}) => { 
    if (effects.length === 0) {
        return [];
    }
    return (
        <div className="effect-choices">
          {Object.keys(effects).map(
              x =>
                  <EffectChoice
                    key={x}
                    isSelected={x === selectedEffect}
                    effect={x}
                    matchedPresets={effects[x]}
                    sequencerEngine={sequencerEngine}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectChoices);
